import { getOnStorage, removeFromStorage } from './storageFunctions';

const SESSION_EXPIRED_MESSAGE = 'Sessão expirada. Por favor, entre com sua conta novamente.';

let isLoggingOut = false;

export const clearSessionStorage = () => {
  removeFromStorage('login_date');
  removeFromStorage('token_magento');
  removeFromStorage('token_aws');
  removeFromStorage('temporary_token_aws');
  removeFromStorage('rca');
  removeFromStorage('selected_client');
  removeFromStorage('selected_rca');
  removeFromStorage('datasets');
  removeFromStorage('discounts');
  removeFromStorage('rca_usuario');
  removeFromStorage('cart_id');
  removeFromStorage('user_login_data');
  removeFromStorage('selected_brand');
  removeFromStorage('has_new_datasets');
  removeFromStorage('last_data_sync');
  localStorage.removeItem('login_bootstrap');
};

const toStatusNumber = (value: unknown): number | undefined => {
  if (typeof value === 'number' && Number.isFinite(value)) return value;
  if (typeof value === 'string' && value.trim() !== '') {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : undefined;
  }
  return undefined;
};

export const getAxiosErrorStatus = (error: unknown): number | undefined => {
  const err = error as any;
  return (
    toStatusNumber(err?.response?.status) ??
    toStatusNumber(err?.status) ??
    toStatusNumber(err?.request?.status)
  );
};

export const isUnauthorizedAxiosError = (error: unknown): boolean => {
  const status = getAxiosErrorStatus(error);
  if (status === 401 || status === 403) return true;
  return false;
};

export const forceSessionExpiredLogout = async (message = SESSION_EXPIRED_MESSAGE) => {
  if (isLoggingOut) return;

  isLoggingOut = true;

  clearSessionStorage();
  window.alert(message);

  try {
    const { deleteDB } = await import('@/talons/dbFunctions/useDBFunctions');
    await deleteDB();
  } catch (error) {
    console.error('Falha ao limpar IndexedDB na expiração de sessão:', error);
  }

  window.location.reload();
};

export const isUnauthorizedGraphQLError = (graphQLErrors: readonly any[] | undefined): boolean => {
  if (!graphQLErrors?.length) return false;

  return graphQLErrors.some((error) => {
    const category = String(error?.extensions?.category || '').toLowerCase();
    const message = String(error?.message || '').toLowerCase();
    return (
      category.includes('authorization') ||
      category.includes('graphql-authentication') ||
      message.includes('unauthorized') ||
      message.includes('acesso negado')
    );
  });
};

export const hasActiveSession = (): boolean => {
  return Boolean(getOnStorage('token_magento') && getOnStorage('rca_usuario')) && !window.location.hash.includes('login');
};
